enum CashCollectionPermission {
  Prem_CashCollection_Add = 'Prem_CashCollection_Add',
  Prem_CashCollection_Manage = 'Prem_CashCollection_Manage',
}

export default CashCollectionPermission;
